import {
  SupportedLanguage,
  defaultLanguage,
  supportedLanguages,
} from "../config/languages";

/**
 * Detects the user's preferred language from the Accept-Language header
 * @param acceptLanguage - The Accept-Language header value
 * @returns The detected supported language or default language as fallback
 */
export function detectLanguage(acceptLanguage: string): SupportedLanguage {
  // Parse the accept-language header to get preferred languages
  const preferredLanguages = acceptLanguage
    .split(",")
    .map((lang) => lang.split(";")[0].trim().toLowerCase())
    .filter(Boolean);

  // Find the first supported language from the users preferences
  const targetLanguage = supportedLanguages.find((supported) =>
    preferredLanguages.some(
      (lang) =>
        supported.code === lang || lang.startsWith(supported.code + "-"),
    ),
  )?.code;

  return targetLanguage || defaultLanguage; // Or fallback to default language
}
